import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const container = document.getElementById('root');

// const adjustZoom = () => {
//   const ratio = window.devicePixelRatio;
//   const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');

//   if (isFirefox) {
//     document.body.style.transform = `scale(${1 / ratio})`;
//     document.body.style.transformOrigin = 'top left';
//     document.body.style.width = `${100 * ratio}%`;
//   } else {
//     (document.body.style as any).zoom = `${1 / window.devicePixelRatio}`;
//   }
// };

// adjustZoom();
// window.addEventListener('resize', adjustZoom);

if (container) {
  const root = ReactDOM.createRoot(container);

  root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
  );
}